document.addEventListener('DOMContentLoaded', function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- 1. Accordions: single-open + smooth height ---- */
  var accordions = document.querySelectorAll('.product__accordion details');
  accordions.forEach(function (d) {
    d.addEventListener('toggle', function () {
      if (!d.open) return;
      accordions.forEach(function (other) {
        if (other !== d && other.open) other.removeAttribute('open');
      });
      if (reduced) return;
      var content = d.querySelector('.accordion__content');
      if (content && content.animate) {
        var h = content.scrollHeight;
        content.animate(
          [{ maxHeight: '0px', opacity: 0 }, { maxHeight: h + 'px', opacity: 1 }],
          { duration: 280, easing: 'cubic-bezier(0.4,0,0.2,1)' }
        );
      }
    });
  });

  /* ---- 2. Add to Cart: "Added ✓" feedback ---- */
  var atcBtn = document.querySelector('.product-form__submit');
  if (atcBtn) {
    var originalText = atcBtn.querySelector('span') ? atcBtn.querySelector('span').textContent : '';
    var pending = false;

    atcBtn.addEventListener('click', function () {
      if (atcBtn.getAttribute('disabled') === null) pending = true;
    });

    var spinner = atcBtn.querySelector('.loading__spinner');
    if (spinner && 'MutationObserver' in window) {
      new MutationObserver(function () {
        var hidden = spinner.classList.contains('hidden');
        if (!hidden || !pending) return;
        pending = false;
        var span = atcBtn.querySelector('span');
        if (!span) return;
        span.textContent = 'Added to Cart ✓';
        atcBtn.classList.add('gx-added');
        setTimeout(function () {
          span.textContent = originalText;
          atcBtn.classList.remove('gx-added');
        }, 1300);
      }).observe(spinner, { attributes: true, attributeFilter: ['class'] });
    }
  }

  /* The mobile sticky add-to-cart bar was moved out of this scrape-the-DOM
     block into the server-rendered <sticky-atc> element (gx-sticky-atc.js),
     which stays correct on variant change and on resize. */
});


/* =========================================================
   GX PURCHASE QUANTITY FIX
   Makes +/- work inside the custom Hanger-style purchase grid
   ========================================================= */

if (!window.gxPurchaseQuantityInitialized) {
  window.gxPurchaseQuantityInitialized = true;

  document.addEventListener(
    'click',
    function (event) {
      const button = event.target.closest(
        '.gx-purchase-grid__quantity .quantity__button'
      );

      if (!button) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      const quantityInput = button.closest('quantity-input');
      const input = quantityInput?.querySelector('.quantity__input');

      if (!input) return;

      const currentValue = Number(input.value) || 1;
      const step = Number(input.step) || 1;

      const min = Number(
        input.getAttribute('min') ||
        input.dataset.min ||
        step
      );

      const maxAttribute =
        input.getAttribute('max') || input.dataset.max;

      const max = maxAttribute ? Number(maxAttribute) : Infinity;

      let nextValue = currentValue;

      if (button.name === 'plus') {
        nextValue = Math.min(currentValue + step, max);
      }

      if (button.name === 'minus') {
        nextValue = Math.max(currentValue - step, min);
      }

      if (nextValue === currentValue) return;

      input.value = nextValue;

      input.dispatchEvent(
        new Event('input', {
          bubbles: true
        })
      );

      input.dispatchEvent(
        new Event('change', {
          bubbles: true
        })
      );
    },
    true
  );
}